import React from 'react';
import { motion } from 'framer-motion';

const timelineData = [
  {
    year: '2025',
    title: 'AI Engineer',
    description: 'Leading development of LLM-powered applications and fake news detection systems using cutting-edge transformer architectures.',
  },
  {
    year: '2024',
    title: 'Full Stack Developer',
    description: 'Built immersive web experiences using THREE.js and modern React frameworks, creating interactive 3D visualizations and simulating a Neural Network from scratch.',
  },
];

const interestsData = [
  { title: 'Quantum Physics', description: 'Exploring the fundamental nature of reality through computational models.' },
  { title: 'Space Technology', description: 'Fascinated by space exploration and making humanity a multi-planetary species.' },
  { title: 'AI Ethics', description: 'Ensuring responsible AI development and deployment in society.' },
  { title: 'Creative Coding', description: 'Merging art and technology through generative algorithms.' },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.3 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

const About: React.FC = () => {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
      className="space-y-20 py-24"
    >
      <motion.p 
        variants={itemVariants}
        className="font-display text-center text-3xl md:text-5xl text-[var(--color-foreground)] max-w-4xl mx-auto leading-tight tracking-tight"
      >
        A passionate engineer working at the intersection of artificial intelligence, theoretical physics, and immersive digital art.
      </motion.p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start max-w-6xl mx-auto">
        <motion.div variants={itemVariants} className="space-y-8">
          <h3 className="font-display text-3xl font-bold text-[var(--color-foreground)] border-b border-[var(--color-border)] pb-4">Professional Journey</h3>
          <div className="space-y-8">
            {timelineData.map((item, index) => (
              <div key={index}>
                <p className="font-display text-2xl text-[var(--color-foreground)]">{item.year}</p>
                <h4 className="text-lg font-semibold text-[var(--color-foreground)] mt-1">{item.title}</h4>
                <p className="text-sm text-[var(--color-muted)] mt-2">{item.description}</p>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div variants={itemVariants} className="space-y-8">
          <h3 className="font-display text-3xl font-bold text-[var(--color-foreground)] border-b border-[var(--color-border)] pb-4">Interests & Curiosities</h3>
          <div className="space-y-6">
            {interestsData.map((interest, index) => (
              <div key={index}>
                <h4 className="font-semibold text-md text-[var(--color-foreground)]">{interest.title}</h4>
                <p className="text-sm text-[var(--color-muted)]">{interest.description}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default About;